export enum Language {
  DEFAULT = 'en-US',
  EN_US = 'en-US',
}
